import { render } from "./TableWarnings.vue?vue&type=template&id=0a33083b"
import script from "./TableWarnings.vue?vue&type=script&lang=js"
export * from "./TableWarnings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__